import request from '@/services/request';
import cloneDeep from '@/utils/cloneDeep';
import getError from '@/services/getError';

export async function getOrgTableDataEge(konkursGroupId, id, year) {
  try {
    if (!konkursGroupId) throw new Error(`konkursGroupId is null`);
    const res = await request({
      endpoint: `/api/${year}/data/challenges/${id}/${konkursGroupId}`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data.sort((el, el1) => el.sortOrder - el1.sortOrder);
    }
  } catch (e) {
    await getError();
    throw new Error('error setBlock' + e);
  }
}
export async function changeOrgTableDataEge(data = {}, otherData = {}, year) {
  try {
    const bufData = cloneDeep(data);
    bufData.challengeSubjectBalls = bufData['challengeSubjectBalls']
      ? bufData['challengeSubjectBalls'].map((el) => {
          return { id: el };
        })
      : null;
    const predmetBall = [];
    for (const item in bufData) {
      const ind = item.indexOf('-');
      if (ind !== -1 && !item.includes('Specific')) {
        const predmetId = item.slice(ind + 1, item.length);
        predmetBall.push({
          eduSubject: { id: Number.parseInt(predmetId) },
          ballMin: bufData[item],
          ballMinSpecific: bufData['ballMinSpecific-' + predmetId],
        });
      }
    }
    const res = await request({
      endpoint: `/api/${year}/data/challenges`,
      method: 'post',
      body: {
        ...bufData,
        challengeSubjectBalls: predmetBall,
        ...otherData,
      },
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    await getError();
    throw new Error('error setBlock' + e);
  }
}
export async function deleteOrgTableDataEge(id, year) {
  try {
    if (!id) throw new Error(`id is null`);
    const res = await request({
      endpoint: `/api/${year}/data/challenges/${id}`,
      method: 'delete',
    });
    if (res.status === 200) {
      return true;
    }
  } catch (e) {
    await getError();
    throw new Error('error setBlock' + e);
  }
}
